<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="ModalBaslik"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
  >
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Cari Adı" prop="adi">
            <el-input type="text" v-model="Form.adi" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Telefon" prop="telefon">
            <el-input type="text" v-model="Form.telefon" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Email" prop="email">
            <el-input type="email" v-model="Form.email" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Vergi No" prop="vno">
            <el-input type="text" v-model="Form.vno" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="Vergi Dairesi" prop="vdaire">
            <el-input type="text" v-model="Form.vdaire" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Banka" prop="banka">
            <el-input type="text" v-model="Form.banka" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Iban" prop="iban">
            <el-input type="text" v-model="Form.iban" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="Adres" prop="adres">
            <el-input type="textarea" v-model="Form.adres" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>
  </el-dialog>

</template>

<script>
import BinaListe from "../../Bina/BinaListe";

export default {
  props: ['Bilgi', 'Durum', 'Tur'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Form: {},
      FormHata: {
        adi: [{required: true, message: "Adı Giriniz", trigger: 'blur'}],
      },
    }
  },
  methods: {
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          this.$store.dispatch(this.Tur, {...this.Form, path: 'cari'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                  if (this.Tur == 'Post') this.$router.push("/cari/");
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  },
  created() {
    if (this.Bilgi) {
      this.Form = this.Bilgi
      this.ModalBaslik = this.Bilgi.Unvan
    } else {
      this.Form = {}
      this.ModalBaslik = 'Cari Ekle'
    }
    this.$store.dispatch("Get", {path: 'cari'})
        .then(response => {
          this.Bolgeler = response.Data
        })
  },
  watch: {
    Bilgi: function () {
      this.Form = this.Bilgi
      this.ModalBaslik = 'Cari Düzenle';

    },
    Tur: function () {
      if (this.Tur == 'Post') this.ModalBaslik = 'Cari Ekle'; else this.ModalBaslik = 'Cari Düzenle';
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/cari/Comp/Modal.vue